<app-header></app-header>
<app-sidebar></app-sidebar>

<main class="full-wrap">
    <div class="main-div">
        <div class="left-section">
            <div class="report-page">
                <div class="filterDiv">
                    <div class="row page-title">
                        <h3 class="col-md-1"><img src="assets/images/icon/my-bet.svg"> My Bet</h3>
                        <div class="col-md-10">
                            <div class="betDetailNav">
                                <ul>
                                    <li>{{sport_name}} </li>
                                    <li>{{series_name}}</li>
                                    <li>{{match_name}}</li>
                                    <li>{{market_name}}</li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-md-1 breadcrumb">
                            <a (click)="goToBack()" class="btn btn-secondary "><i class="fa fa-arrow-left"></i> Back</a>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div>
                                <div class="row form-field">

                                    <div class="col-md-2 col">
                                        <div class="col-inner">
                                            <div class="form-group">
                                                <select name="betType" class="form-select" [(ngModel)]="betType"
                                                    [ngModelOptions]="{standalone: true}"
                                                    aria-label="Default select example"
                                                    (change)="onClickFilterViewBets()">
                                                    <option selected disabled>Bet Type</option>
                                                    <option value="All">All</option>
                                                    <option value="Back">Back</option>
                                                    <option value="Lay">Lay</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-2 col">
                                        <div class="col-inner">
                                            <div class="form-group mb-0">

                                                <input name="searchRate" class="search-input form-control" type="text"
                                                    autocomplete="off" [(ngModel)]="searchRate" placeholder="Rate"
                                                    (blur)="onClickFilterViewBets('filterBtnClick')">


                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-2 col">
                                        <div class="col-inner">
                                            <div class="form-group mb-0">

                                                <input name="searchStake" class="search-input form-control" type="text"
                                                    autocomplete="off" [(ngModel)]="searchStake" placeholder="Stake"
                                                    (blur)="onClickFilterViewBets('filterBtnClick')">


                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-2 col">
                                        <div class="col-inner text-end">
                                            <div class="btn-list">
                                                <button type="button" class="btn btn-success"
                                                    (click)="onClickFilterViewBets('filterBtnClick')">Filter</button>
                                                <button type="button" class="btn btn-danger"
                                                    (click)="clear()">Clear</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- <div class="row">
                    <div class="col-md-12">
                        <div class="report-table">
                       
                            <!-- <table datatable class="table">
                                <thead>
                                    <tr>
                                        <th>Bet ID</th>
                                        <th>Event</th>
                                        <th>Market</th>
                                        <th>Selection</th>
                                        <th>Type</th>
                                        <th>Odds</th>
                                        <th>Stake</th>
                                        <th>Placed Time</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Date</td>
                                        <td>Name</td>
                                        <td>Description</td>
                                        <td>Credit</td>
                                        <td>Debit</td>
                                        <td>Balance</td>
                                        <td>Debit</td>
                                        <td>Balance</td>
                                    </tr>
                                </tbody>
                            </table> -->
                <!-- </div>
                    </div>
                </div> -->
                <table mat-table [dataSource]="myBetsDataSource" class="mat-elevation-z8">

                    <!-- <ng-container matColumnDef="result_date">
                        <th mat-header-cell *matHeaderCellDef>S.No.</th>
                        <td mat-cell *matCellDef="let element; let i=index">{{i+1}}</td>
                    </ng-container> -->
                    <!-- <ng-container matColumnDef="user_name">
                        <th mat-header-cell *matHeaderCellDef>Name</th>
                        <td mat-cell *matCellDef="let element"> {{element.user_name }}</td>
                    </ng-container> -->
                    <ng-container matColumnDef="number">
                        <th mat-header-cell *matHeaderCellDef> S.No. </th>
                        <td mat-cell *matCellDef="let element ; let elementIndex = index;"  > {{elementIndex+1}} </td>
                    </ng-container>
                    <!-- Name Column -->
                    <ng-container matColumnDef="market_name">
                        <th mat-header-cell *matHeaderCellDef> Market </th>
                        <td mat-cell *matCellDef="let element"> 
                            <span class="market-name">{{element.market_name}}</span> </td>
                    </ng-container>

                    <!-- selection Column -->

                    <ng-container matColumnDef="selection_name">
                        <th mat-header-cell *matHeaderCellDef>Selection</th>
                        <td mat-cell *matCellDef="let element">
                            <span class="selection">{{element.is_fancy == 0 ? element.selection_name :
                                element.selection_name}} </span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="odds">
                        <th mat-header-cell *matHeaderCellDef>Rate</th>
                        <td mat-cell *matCellDef="let element"> <span>{{element.odds | number : '0.0-2'}} </span></td>
                    </ng-container>
                    <ng-container matColumnDef="stack">
                        <th mat-header-cell *matHeaderCellDef>Stake</th>
                        <td mat-cell *matCellDef="let element"><span class="stake">{{element.stack | number :
                                '0.0-2'}}</span></td>
                    </ng-container>
                    <ng-container matColumnDef="p_l">
                        <th mat-header-cell *matHeaderCellDef>P | L </th>
                        <td mat-cell *matCellDef="let element"> <span
                                [ngClass]="{'loss':element.p_l < 0 ,'profit':element.p_l >= 0}">{{element.p_l | number :
                                '0.0-2'}} </span></td>
                    </ng-container>
                    <ng-container matColumnDef="result">
                        <th mat-header-cell *matHeaderCellDef>Result </th>
                        <td mat-cell *matCellDef="let element"> <span>{{element.winner_name }} </span></td>
                    </ng-container>
                    <ng-container matColumnDef="is_back">
                        <th mat-header-cell *matHeaderCellDef>Bet Type</th>
                        <td mat-cell *matCellDef="let element">
                            <span class="lay-btn" *ngIf="(element.is_back)==0"><span>Lay</span></span>
                            <span class="back-btn" *ngIf="(element.is_back)==1"><span>Back</span></span>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="createdAt">
                        <th mat-header-cell *matHeaderCellDef> Placed Time </th>
                        <td mat-cell *matCellDef="let element">
                            <span class="date">{{element.createdAt | date :'dd-MM-yyyy hh:mm:ss aa'}}</span>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="myBetsDisplayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: myBetsDisplayedColumns;"></tr>
                </table>
                <mat-paginator [pageSize]="50" (page)="pageChange($event)" [pageIndex]="pageIndex"
                    [pageSizeOptions]="[50, 100,150, 200]" [length]="length" aria-label="Select page of users">
                </mat-paginator>
            </div>
        </div>
    </div>
</main>